import React, { useState } from 'react'
import { trackBookingClick } from '../lib/tracking'

interface PricingItem {
  category: string
  area: string
  standard: string
  loyalty: string
  loyalty7: string
  prepaid7: string
  popular?: boolean
}

const pricingData: PricingItem[] = [
  // Lice
  { category: 'Lice', area: 'Nadusnica / brada / obrazi / nos', standard: '55 €', loyalty: '38,50 €', loyalty7: '286 €', prepaid7: '247,50 €', popular: true },
  { category: 'Lice', area: 'Ušne resice / između obrva', standard: '55 €', loyalty: '38,50 €', loyalty7: '286 €', prepaid7: '247,50 €' },
  { category: 'Lice', area: 'Nadusnice i brada / oblikovanje', standard: '112 €', loyalty: '78,40 €', loyalty7: '582,40 €', prepaid7: '504 €' },
  { category: 'Lice', area: 'Nadusnica, brada i linija čeljusti', standard: '140 €', loyalty: '98 €', loyalty7: '728 €', prepaid7: '630 €' },
  { category: 'Lice', area: 'Zalisci', standard: '60 €', loyalty: '42 €', loyalty7: '312 €', prepaid7: '270 €' },
  { category: 'Lice', area: 'Cijelo lice / pola lica i vrat (žene)', standard: '183 €', loyalty: '128,10 €', loyalty7: '951,60 €', prepaid7: '823,50 €' },
  { category: 'Lice', area: 'Vrat', standard: '80 €', loyalty: '56 €', loyalty7: '416 €', prepaid7: '360 €' },
  { category: 'Lice', area: 'Muška brada', standard: '205 €', loyalty: '143,50 €', loyalty7: '1.066 €', prepaid7: '922,50 €' },

  // Intimne / manje zone
  { category: 'Intimne i manje zone', area: 'Pazusi', standard: '120 €', loyalty: '84 €', loyalty7: '624 €', prepaid7: '540 €', popular: true },
  { category: 'Intimne i manje zone', area: 'Bikini line', standard: '120 €', loyalty: '84 €', loyalty7: '624 €', prepaid7: '540 €' },
  { category: 'Intimne i manje zone', area: 'Bikini Brazilian', standard: '160 €', loyalty: '112 €', loyalty7: '832 €', prepaid7: '720 €', popular: true },
  { category: 'Intimne i manje zone', area: 'Bikini Hollywood', standard: '180 €', loyalty: '126 €', loyalty7: '936 €', prepaid7: '810 €' },
  { category: 'Intimne i manje zone', area: 'Bikini — cijela zona', standard: '200 €', loyalty: '140 €', loyalty7: '1.040 €', prepaid7: '900 €' },
  { category: 'Intimne i manje zone', area: 'Bradavice', standard: '80 €', loyalty: '56 €', loyalty7: '416 €', prepaid7: '360 €' },
  { category: 'Intimne i manje zone', area: 'Nadlanice', standard: '60 €', loyalty: '42 €', loyalty7: '312 €', prepaid7: '270 €' },
  { category: 'Intimne i manje zone', area: 'Prsti', standard: '35 €', loyalty: '24,50 €', loyalty7: '182 €', prepaid7: '157,50 €' },
  { category: 'Intimne i manje zone', area: 'Područje pupka', standard: '35 €', loyalty: '24,50 €', loyalty7: '182 €', prepaid7: '157,50 €' },

  // Tijelo
  { category: 'Tijelo', area: 'Cijele noge', standard: '350 €', loyalty: '245 €', loyalty7: '1.820 €', prepaid7: '1.575 €', popular: true },
  { category: 'Tijelo', area: 'Potkoljenice', standard: '175 €', loyalty: '122,50 €', loyalty7: '910 €', prepaid7: '787,50 €' },
  { category: 'Tijelo', area: 'Natkoljenice', standard: '235 €', loyalty: '164,50 €', loyalty7: '1.222 €', prepaid7: '1.057,50 €' },
  { category: 'Tijelo', area: 'Pola ruku', standard: '120 €', loyalty: '84 €', loyalty7: '624 €', prepaid7: '540 €' },
  { category: 'Tijelo', area: 'Cijele ruke', standard: '150 €', loyalty: '105 €', loyalty7: '780 €', prepaid7: '675 €' },
  { category: 'Tijelo', area: 'Pola leđa (muškarci) / cijela leđa (žene)', standard: '210 €', loyalty: '147 €', loyalty7: '1.092 €', prepaid7: '945 €' },
  { category: 'Tijelo', area: 'Cijela leđa', standard: '300 €', loyalty: '210 €', loyalty7: '1.560 €', prepaid7: '1.350 €' },
  { category: 'Tijelo', area: 'Stražnjica', standard: '160 €', loyalty: '112 €', loyalty7: '832 €', prepaid7: '729 €' },
  { category: 'Tijelo', area: 'Prsa / trbuh', standard: '160 €', loyalty: '112 €', loyalty7: '832 €', prepaid7: '810 €' },
  { category: 'Tijelo', area: 'Prsa i trbuh', standard: '200 €', loyalty: '140 €', loyalty7: '1.040 €', prepaid7: '900 €' },
  { category: 'Tijelo', area: 'Prsna kost', standard: '140 €', loyalty: '98 €', loyalty7: '728 €', prepaid7: '630 €' },
]

const categories = ['Lice', 'Intimne i manje zone', 'Tijelo']

export default function PricingTable() {
  const [activeCategory, setActiveCategory] = useState<string>('Lice')
  const items = pricingData.filter((item) => item.category === activeCategory)

  return (
    <section className="animate-on-scroll py-16 px-4" style={{ backgroundColor: 'var(--medispa-cloud)' }}>
      <div className="max-w-6xl mx-auto">
        <p className="text-center text-xs tracking-[0.18em] uppercase mb-3 font-semibold" style={{ color: 'var(--medispa-olive)' }}>
          Cjenik 2025
        </p>
        <h2 className="text-4xl md:text-5xl font-bold mb-4 text-center" style={{ color: 'var(--medispa-olive)' }}>
          Cijene tretmana
        </h2>
        <p className="text-lg text-center mb-8 max-w-2xl mx-auto" style={{ color: 'var(--medispa-dark-grey)' }}>
          Transparentne cijene uz Loyalty pogodnosti i pakete od 7 tretmana koji donose najbolju vrijednost
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-8" role="tablist" aria-label="Kategorije tretmana">
          {categories.map((category) => {
            const isActive = category === activeCategory
            return (
              <button
                key={category}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => setActiveCategory(category)}
                className="px-5 py-2.5 rounded-full text-sm font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2"
                style={
                  isActive
                    ? { backgroundColor: 'var(--medispa-olive)', color: '#ffffff' }
                    : { backgroundColor: '#ffffff', color: 'var(--medispa-moss)', border: '1px solid rgba(118,128,100,0.35)' }
                }
              >
                {category}
              </button>
            )
          })}
        </div>

        {/* Desktop table */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full bg-white rounded-lg shadow-lg overflow-hidden">
            <thead style={{ backgroundColor: 'var(--medispa-olive)' }}>
              <tr>
                <th className="px-5 py-4 text-left text-white font-semibold text-base">Tretman</th>
                <th className="px-4 py-4 text-center text-white font-semibold text-base">Standardna cijena</th>
                <th className="px-4 py-4 text-center text-white font-semibold text-base">Loyalty −30%</th>
                <th className="px-4 py-4 text-center text-white font-semibold text-base">Loyalty 7 tretmana</th>
                <th className="px-4 py-4 text-center text-white font-semibold text-base">Paket 7 unaprijed −10%</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr
                  key={item.area}
                  className="border-b border-gray-200 transition-colors"
                  style={item.popular ? { backgroundColor: 'var(--medispa-aloe)' } : {}}
                >
                  <td className="px-5 py-3 font-medium" style={{ color: 'var(--medispa-moss)' }}>
                    <span className="flex items-center gap-2 flex-wrap">
                      {item.area}
                      {item.popular ? (
                        <span className="text-xs px-2 py-0.5 rounded-full text-white" style={{ backgroundColor: 'var(--medispa-olive)' }}>
                          Popularno
                        </span>
                      ) : null}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-center" style={{ color: 'var(--medispa-text-grey)' }}>
                    {item.standard}
                  </td>
                  <td className="px-4 py-3 text-center font-medium" style={{ color: 'var(--medispa-moss)' }}>
                    {item.loyalty}
                  </td>
                  <td className="px-4 py-3 text-center" style={{ color: 'var(--medispa-text-grey)' }}>
                    {item.loyalty7}
                  </td>
                  <td className="px-4 py-3 text-center font-bold" style={{ color: 'var(--medispa-olive)' }}>
                    {item.prepaid7}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile cards */}
        <div className="md:hidden space-y-4">
          {items.map((item) => (
            <div key={item.area} className="bg-white rounded-lg shadow-md p-5">
              <div className="flex items-start justify-between gap-3 mb-3">
                <h3 className="font-semibold text-base" style={{ color: 'var(--medispa-moss)' }}>
                  {item.area}
                </h3>
                {item.popular ? (
                  <span className="text-xs px-2 py-0.5 rounded-full text-white whitespace-nowrap" style={{ backgroundColor: 'var(--medispa-olive)' }}>
                    Popularno
                  </span>
                ) : null}
              </div>
              <dl className="space-y-2 text-sm">
                <div className="flex justify-between gap-3">
                  <dt style={{ color: 'var(--medispa-text-grey)' }}>Standardna cijena</dt>
                  <dd style={{ color: 'var(--medispa-text-grey)' }}>{item.standard}</dd>
                </div>
                <div className="flex justify-between gap-3">
                  <dt style={{ color: 'var(--medispa-text-grey)' }}>Loyalty −30%</dt>
                  <dd className="font-medium" style={{ color: 'var(--medispa-moss)' }}>{item.loyalty}</dd>
                </div>
                <div className="flex justify-between gap-3">
                  <dt style={{ color: 'var(--medispa-text-grey)' }}>Loyalty 7 tretmana</dt>
                  <dd style={{ color: 'var(--medispa-text-grey)' }}>{item.loyalty7}</dd>
                </div>
                <div className="flex justify-between gap-3 pt-2 border-t border-gray-200">
                  <dt className="font-semibold" style={{ color: 'var(--medispa-moss)' }}>Paket 7 unaprijed −10%</dt>
                  <dd className="font-bold" style={{ color: 'var(--medispa-olive)' }}>{item.prepaid7}</dd>
                </div>
              </dl>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-white rounded-lg p-6 shadow-sm">
          <h3 className="text-lg font-semibold mb-4" style={{ color: 'var(--medispa-olive)' }}>
            Kako funkcioniraju cijene
          </h3>
          <ul className="space-y-2 text-sm" style={{ color: 'var(--medispa-dark-grey)' }}>
            <li>
              <strong>Standardna cijena</strong> — cijena pojedinačnog tretmana.
            </li>
            <li>
              <strong>Loyalty −30%</strong> — cijena svakog sljedećeg tretmana za klijente koji nastave svoj plan tretmana.
            </li>
            <li>
              <strong>Loyalty 7 tretmana</strong> — ukupan iznos za cijeli plan: prvi tretman po standardnoj cijeni, a preostalih šest uz Loyalty popust od 30%.
            </li>
            <li>
              <strong>Paket 7 unaprijed −10%</strong> — najbolja vrijednost: paket od 7 tretmana plaćate unaprijed uz dodatnih 10% popusta.
            </li>
          </ul>
        </div>

        <div className="mt-10 text-center">
          <p className="text-sm mb-4" style={{ color: 'var(--medispa-text-grey)' }}>
            Konačna cijena potvrđuje se na besplatnim konzultacijama, nakon procjene područja i vašeg plana tretmana.
          </p>
          <div className="button-wrapper inline-block">
            <a
              className="inline-block px-8 py-4 rounded-md text-white font-semibold transition-all"
              style={{ backgroundColor: 'var(--medispa-olive)' }}
              href="https://medispahr.wixforms.com/f/7479898417246766083"
              target="_blank"
              rel="noopener noreferrer"
              data-cta="book_now"
              data-cta-location="pricing"
              onClick={() => trackBookingClick('pricing')}
            >
              <span style={{ color: 'white' }}>Rezerviraj besplatnu konzultaciju</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
